import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ActiveVasOffersUIHelpers";

const ActiveVasOffersUIContext = createContext();

export function useActiveVasOffersUIContext() {
  return useContext(ActiveVasOffersUIContext);
}

export const ActiveVasOffersUIConsumer = ActiveVasOffersUIContext.Consumer;

export function ActiveVasOffersUIProvider({ activeVasOffersUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openUpdateActiveVasOffersStatusDialog:
      activeVasOffersUIEvents.openUpdateActiveVasOffersStatusDialog,
    openRateOfferDialog:
      activeVasOffersUIEvents.openRateOfferDialog,
  };

  return (
    <ActiveVasOffersUIContext.Provider value={value}>
      {children}
    </ActiveVasOffersUIContext.Provider>
  );
}
